<template>
  <div :class="'md-layout-item md-small-size-100'">
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{ 'md-error': $v.review.reference.$error }">
          <label>Review Reference</label>
          <md-input v-model="review.reference" @blur="$v.review.reference.$touch()" type="text" maxlength="254">
          </md-input>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{ 'md-error': $v.review.fiscal_year.$error }">
          <label>Fiscal Year</label>
          <md-select v-model="review.fiscal_year" md-dense>
            <md-option v-for="(year, idx) in fiscalYears" :key="idx" :value="year">
              {{ year }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field>
          <label :class="'title-select'">Reviewer</label>
          <select :class="'custom-select'" placeholder="Reviewer" v-model="review.rqr_leader" md-dense>
            <option value="null">Reviewer</option>
            <option :value="user.id" v-for="(user, i) in leadersUsers" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-datepicker data-model="deadline_docs" v-model="review.deadline_docs" md-immediately
          :class="{ 'md-error': $v.review.deadline_docs.$error }">
          <label>Deadline Docs</label>
        </md-datepicker>
      </div>
    </div>

    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-datepicker data-model="start_date" v-model="review.start_date" md-immediately
          :class="{ 'md-error': $v.review.start_date.$error }">
          <label>Start Date</label>
        </md-datepicker>
      </div>
      <div :class="'md-layout-item'">
        <md-datepicker data-model="end_date" v-model="review.end_date" md-immediately :md-clearable="false"
          :class="{ 'md-error': $v.review.end_date.$error }">
          <label>End Date</label>
        </md-datepicker>
      </div>
    </div>

    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <label :class="'md-layout-item md-size-15 md-form-label'">
          RQR Type:
        </label>
        <md-radio v-for="(value, code) in listOfRqrType()" :key="code" v-model="review.rqr_type" :value="value.code">
          {{ value.label }}
        </md-radio>
      </div>
      <div :class="'md-layout-item'" v-if="review.questionnaire">
        <md-field>
          <label>Questionnaire</label>
          <md-input v-model="review.questionnaire.name" type="text" disabled maxlength="254">
          </md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import * as utils from "@/utils"
import { rqrTypesMap } from "@/filters/rqrType"
import rqrTypeEnum from "@/enums/rqrType"

export default {
  created() {
    this.$api.request('all/users')
      .then(response => {
        this.leadersUsers = response.data
          .filter(d => d.inactiveUser === null)
          // .sort((a, b) => a.name.localeCompare(b.name))
      })
  },

  data() {
    return {
      review: {
        reference: '',
        fiscal_year: null,
        rqr_type: rqrTypeEnum.COMPLICE,
        start_date: '',
        end_date: '',
        deadline_docs: '',
        rqr_leader: null,
        attachments: null
      },
      leadersUsers: [],
      isSubmitting: false,
    }
  },

  mounted() {
    this.enableClearField()
  },

  computed: {
    fiscalYears() {
      return utils.getFiscalYears();
    },
  },

  methods: {
    enableClearField() {
      document.querySelectorAll('.md-field.md-clearable.md-datepicker')
        .forEach(closeEl => {
          closeEl.addEventListener('click', e => {
            if (e.target.classList.contains('md-ripple') || e.target.closest('.md-ripple'))
              this.review[closeEl.dataset.model] = null
          })
        })
    },

    listOfRqrType(){
      const rqrTypeArray = [];
      Object.entries(rqrTypesMap).forEach(([key, value]) =>
        rqrTypeArray.push({label: value, code: Number(key)})
      )
      return rqrTypeArray;
    },
  },

  props: {
    fetchedReview: {
      type: Object,
    },
  },

  validations: {
    review: {
      reference: {
        required,
        maxLength: maxLength(254)
      },
      fiscal_year: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4)
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      deadline_docs: {
        required
      },
    },
  },

  watch: {
    '$v.review.$invalid': function () {
      this.$emit('setFormValidation', !this.$v.review.$invalid, this.review)
    },

    fetchedReview() {
      this.review = this.fetchedReview
    },
  },
}
</script>
